__turbopack_context__.v({
  "carInfo": "GuideSection-module__W9m8dq__carInfo",
  "ctaBlock": "GuideSection-module__W9m8dq__ctaBlock",
  "ctaBlockWrapper": "GuideSection-module__W9m8dq__ctaBlockWrapper",
  "date": "GuideSection-module__W9m8dq__date",
  "guide_section": "GuideSection-module__W9m8dq__guide_section",
  "header": "GuideSection-module__W9m8dq__header",
  "imageSection": "GuideSection-module__W9m8dq__imageSection",
  "rating": "GuideSection-module__W9m8dq__rating",
  "richTextElement": "GuideSection-module__W9m8dq__richTextElement",
  "title": "GuideSection-module__W9m8dq__title",
});
